export const CloseClicked = 'airportsField/closeClicked';
export const ResetClicked = 'airportsField/resetClicked';
export const AirportToggled = 'airportsField/airportToggled';
export const ValueChanged = 'airportsField/valueChanged';
export const FunctionValueChanged = 'airportsField/functionValueChanged';
export const SuggestionsNoMatch = 'airportsField/suggestionsNoMatch';